<template>
    <content-view>
        <template #header>
            <div class="home-head">
                <div class="home-headline">{{ $t("home.headline-" + daytimeKey) + userName}}</div>
                <v-spacer></v-spacer>
                <div class="sub-header">{{ $t("home.select-text") }}</div>
            </div>
        </template>
        
        <template #content>
            <div class="grid-main-template">
                <router-button 
                    :route="'menu'" 
                    :headlineColor="'#005AB4'"
                    :iconColor="'white'" 
                    :icon="'mdi-silverware-fork-knife'" 
                    :text="$t('nav.menu')">
                </router-button>
                <div class="news-button-wrapper">
                    <router-button 
                        class="news-button"
                        :route="'news'" 
                        :headlineColor="'#00B4B0'" 
                        :iconColor="'white'" 
                        :icon="'mdi-bullhorn-outline'" 
                        :text="$t('nav.news')">
                    </router-button>
                    <div v-if="unreadNews.length > 0" class="unread-news">{{unreadNews.length}}</div>
                </div>
                <router-button 
                    :route="'appointment'" 
                    :params="{date: today}"
                    :headlineColor="'#FFA015'" 
                    :iconColor="'white'" 
                    :icon="'mdi-notebook-outline'" 
                    :text="$t('nav.appointment')">
                </router-button>
                <router-button 
                    :route="'event'" 
                    :params="{date: today}"
                    :headlineColor="'#74AE2A'" 
                    :iconColor="'white'" 
                    :icon="'mdi-calendar-month-outline'" 
                    :text="$t('nav.event')">
                </router-button>
                <router-button 
                    :route="'video-call'" 
                    :headlineColor="'#9BC2E6'" 
                    :iconColor="'white'" 
                    :icon="'mdi-emoticon-happy-outline'" 
                    :text="$t('nav.video-call')" :disabled="true">
                </router-button>
                <router-button 
                    :route="'feuchter-tv'" 
                    :headlineColor="'#FF6699'" 
                    :iconColor="'white'" 
                    :icon="'mdi-video-vintage'" 
                    :text="$t('nav.feuchter-tv')" :disabled="true">
                </router-button>
            </div>
        </template>
    </content-view>
</template>
<style lang="scss">
.home-head {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.home-headline{
    font: normal normal normal 5vh/7vh 'RobotoMedium';
    letter-spacing: 4px !important;
    color: $font-color !important;
}
.sub-header{
    white-space: pre-wrap;
    font: normal normal normal 3vh/4vh 'RobotoRegular';
    letter-spacing: 2.5px !important;
    color: $font-color !important;
}

.grid-main-template {
    height: 100%;
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 5% 4%;
}
.news-button-wrapper {
    position: relative;
}
.news-button {
    height: 100%;
}
.unread-news {
    position: absolute;
    top: -20px;
    right: -20px;
    background-color: #B71717;
    width: calc(max(3vw, 3vh, 40px));
    height: calc(max(3vw, 3vh, 40px));
    color: white;
    font-size: calc(max(1.5vw, 1.5vh, 20px));
    text-align: center;
    border-radius: calc(max(1.5vw, 1.5vh, 20px));
    line-height: calc(max(3vw, 3vh, 40px));
}
</style>
<script>
import moment from 'moment';
export default {
    data() {
        return {
            currentTime: null,
        }
    },
    created() {
        this.currentTime = moment.now();
    },
    mounted() {
        this.$store.dispatch({
            type: 'moduleUser/fetchUser',
        }).catch((error) => {
            if(error?.response) {
                let requestHost = new URL(error.response.config.url).host;
                let apiHost = new URL(process.env.VUE_APP_API_HOST).host;
                if(requestHost === apiHost && error.response.status === 401) {
                    this.$root.$emit('unauthenticated');
                } else {
                    this.apiErrorMessageHandler(error);
                }
            } else {
                this.apiErrorMessageHandler(error);
            }
        });
        setInterval(() => {
            this.currentTime = moment.now();
        }, 60000);
    },
    computed: {
        daytimeKey: function() {
            const timeFormat = 'HH:mm:ss';
            let now = moment(this.currentTime);
            if(now.isBetween(moment('00:00:00', timeFormat), moment('10:59:59', timeFormat), '[]')) {
                return 'morning';
            } else if(now.isBetween(moment('17:00:00', timeFormat), moment('23:59:59', timeFormat), '[]')){
                return 'night';
            } else {
                return 'day';
            }
        },
        today() {
            return moment(moment.now()).format('YYYY-MM-DD');
        },
        unreadNews() {
            return this.$store.getters['moduleNews/unreadNews'];
        },
        userName() {
            return this.user === null ? '.' : ', ' + this.user.firstname + ' ' + this.user.lastname;
        },
        user() {
            return this.$store.getters['moduleUser/user'];
        },
    }
}
</script>
